// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertToString = (value: any): string => {
  if (value === undefined || value === null) return '';
  return String(value);
};
